/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EvidenceRecordErrors
 */
export interface EvidenceRecordErrors {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordErrors
     */
    'detectedDpi'?: EvidenceRecordErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordErrors
     */
    'calculatedDpi'?: EvidenceRecordErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordErrors
     */
    'colorGradation'?: EvidenceRecordErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordErrors
     */
    'heightMillis'?: EvidenceRecordErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordErrors
     */
    'widthMillis'?: EvidenceRecordErrorsWidthMillisEnum;
}

export const EvidenceRecordErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordErrorsDetectedDpiEnum = typeof EvidenceRecordErrorsDetectedDpiEnum[keyof typeof EvidenceRecordErrorsDetectedDpiEnum];
export const EvidenceRecordErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordErrorsCalculatedDpiEnum = typeof EvidenceRecordErrorsCalculatedDpiEnum[keyof typeof EvidenceRecordErrorsCalculatedDpiEnum];
export const EvidenceRecordErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceRecordErrorsColorGradationEnum = typeof EvidenceRecordErrorsColorGradationEnum[keyof typeof EvidenceRecordErrorsColorGradationEnum];
export const EvidenceRecordErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordErrorsHeightMillisEnum = typeof EvidenceRecordErrorsHeightMillisEnum[keyof typeof EvidenceRecordErrorsHeightMillisEnum];
export const EvidenceRecordErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordErrorsWidthMillisEnum = typeof EvidenceRecordErrorsWidthMillisEnum[keyof typeof EvidenceRecordErrorsWidthMillisEnum];


